

export class Area {
  shape: string;
  coords: string;
  choiceValue: string;
}
